"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupInfoCard = void 0;
const react_1 = __importStar(require("react"));
const Yup = __importStar(require("yup"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const core_ui_1 = require("@sierralabs/core-ui");
const react_material_ui_formik_1 = require("@sierralabs/react-material-ui-formik");
const useUpdateGroup_1 = require("../hooks/useUpdateGroup");
function getInitialValues(group) {
    return {
        name: (group === null || group === void 0 ? void 0 : group.name) || '',
        description: (group === null || group === void 0 ? void 0 : group.description) || ''
    };
}
const GroupInfoCard = props => {
    const { group, onChange } = props;
    const onChangeRef = (0, react_1.useRef)(onChange);
    onChangeRef.current = onChange;
    const formikRef = (0, react_1.useRef)(null);
    const { updatedGroup, isUpdating, updateError, updateGroup } = (0, useUpdateGroup_1.useUpdateGroup)(group.id);
    const [initialValues, setInitialValues] = (0, react_1.useState)(() => {
        return getInitialValues(group);
    });
    // set the initial state of the form once loaded
    (0, react_1.useEffect)(() => {
        setInitialValues(getInitialValues(group));
    }, [group]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (updatedGroup) {
            (_a = onChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeRef, updatedGroup);
        }
    }, [updatedGroup]);
    return (react_1.default.createElement(core_1.Card, null,
        react_1.default.createElement(core_ui_1.CardTitle, null,
            react_1.default.createElement(icons_1.Person, null),
            "Group Info"),
        react_1.default.createElement(core_ui_1.CardContent, { padding: 'large' },
            react_1.default.createElement(react_material_ui_formik_1.InlineFormik, { innerRef: formik => (formikRef.current = formik), initialValues: initialValues, validationSchema: Yup.object({
                    name: Yup.string().required('Required'),
                    description: Yup.string().optional()
                }), isSubmitting: isUpdating, onSubmit: (group) => {
                    updateGroup({ name: group.name, description: group.description });
                } },
                react_1.default.createElement(react_material_ui_formik_1.InlineForm, null,
                    react_1.default.createElement(react_material_ui_formik_1.InlineTextField, { name: 'name', label: 'Name', placeholder: 'Enter the Group name', grid: { xs: 12, md: 12 } }),
                    react_1.default.createElement(react_material_ui_formik_1.InlineTextField, { name: 'description', label: 'Description', placeholder: 'Enter the Group description', grid: { xs: 12, md: 12 } }))),
            react_1.default.createElement(core_ui_1.AppSnackbar, { severity: 'error', open: !!updateError }, (updateError === null || updateError === void 0 ? void 0 : updateError.message) || 'An error occurred while saving.'))));
};
exports.GroupInfoCard = GroupInfoCard;
exports.default = exports.GroupInfoCard;
//# sourceMappingURL=GroupInfoCard.js.map